import React, { useState, useEffect } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import sideImage1 from '../../Common/Images/sideimage1.gif';
import continue_n from '../../Common/Images/continue_n.gif';
import continue_o from '../../Common/Images/continue_o.gif';
import Loading from '../../Common/Loading';
import CustomAlert from '../../Common/CustomAlert';

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const EL_SetWork: React.FC = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const schoolCode = searchParams.get('SchoolCode') || '';
    const { returnPath, parentReturnPath, editingContext, isEditMode, workId } = location.state || {};

    const [studentName, setStudentName] = useState<string>('');
    const [familyCode, setFamilyCode] = useState<string>('');
    const [gradeYear, setGradeYear] = useState<string>('');

    const [workTitle, setWorkTitle] = useState<string>('');
    const [isContinueHovered, setIsContinueHovered] = useState<boolean>(false);

    const [alertInfo, setAlertInfo] = useState({ show: false, message: '' });

    const getFormattedDate = (daysToAdd: number = 0) => {
        const date = new Date();
        date.setDate(date.getDate() + daysToAdd);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [startDate, setStartDate] = useState<string>(getFormattedDate(0));
    const [startTime, setStartTime] = useState<string>('00:00');
    const [finishDate, setFinishDate] = useState<string>(getFormattedDate(9));
    const [endTime, setEndTime] = useState<string>('23:59');

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const [editingPhase2Data, setEditingPhase2Data] = useState<any>(null);

    useEffect(() => {
        const fetchContext = async () => {
            try {
                const pFamilyCode = searchParams.get('Work2FamilyCode') || '';
                const pLogin = searchParams.get('Work2Login') || '';
                const pGrade = searchParams.get('GradeYear') || '';
                const pSchool = searchParams.get('SchoolCode') || '';

                setFamilyCode(pFamilyCode);

                const params = new URLSearchParams({
                    Work2FamilyCode: pFamilyCode,
                    Work2Login: pLogin,
                    GradeYear: pGrade,
                    SchoolCode: pSchool
                });

                const response = await fetch(`${API_BASE_URL}api/get_set_work_context/?${params.toString()}`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                });

                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const data = await response.json();
                if (data) {
                    setStudentName(data.studentName || pLogin);
                    setGradeYear(data.gradeYear || pGrade);
                }
            } catch (error) {
                console.error("Failed to load context", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchContext();
    }, [searchParams]);

    useEffect(() => {
        const editWorkID = searchParams.get('WorkID');

        if (editWorkID && schoolCode) {
            fetchWorkDetails(editWorkID);
        } else {
            setStudentName(searchParams.get('StudentName') || '');
            setGradeYear(searchParams.get('GradeYear') || '');
            setFamilyCode(searchParams.get('Work2FamilyCode') || '');
        }
    }, [searchParams, schoolCode]);

    const fetchWorkDetails = async (workId: string) => {
        setIsLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}api/homework/${workId}/?SchoolCode=${schoolCode}`);
            const data = await response.json();

            if (data && !data.error) {
                setWorkTitle(data.title);

                setStartDate(data.startDate.split('T')[0]);
                setFinishDate(data.endDate.split('T')[0]);

                if (data.startTime) setStartTime(data.startTime);
                if (data.endTime) setEndTime(data.endTime);

                if (data.assignType === 'student' || data.assignType === 'individual') {
                }

                setEditingPhase2Data({
                    subject: data.subject,
                    dicCode: data.dicCode,
                    unitCode: data.unitCode,
                    selectedActivities: data.activities
                });
            } else {
                setAlertInfo({ show: true, message: "Failed to load homework details." });
            }
        } catch (error) {
            console.error("Error fetching work:", error);
            setAlertInfo({ show: true, message: "Error loading data." });
        } finally {
            setIsLoading(false);
        }
    };

    const handleContinue = () => {
        if (!workTitle.trim()) {
            setAlertInfo({ show: true, message: "Please enter a Work Title." });
            return;
        }

        const nextParams = new URLSearchParams(searchParams);
        nextParams.set('WorkTitle', workTitle);
        nextParams.set('StartDate', startDate);
        nextParams.set('FinishDate', finishDate);
        nextParams.set('StartTime', startTime);
        nextParams.set('EndTime', endTime);
        nextParams.set('StudentName', studentName);
        if (workId) nextParams.set('WorkID', workId);

        const navigationState = {
            editingContext: editingPhase2Data,
            returnPath,
            parentReturnPath
        };

        navigate({
            pathname: '/SCHOOL/Teacher/EL_SetWorkPhase2',
            search: `?${nextParams.toString()}`
        }, {
            state: navigationState
        });
    };

    const handleCancel = () => {
        const returnPathFromState = returnPath;
        const returnPathFromParams = searchParams.get('ReturnPath');
        const finalReturnPath = returnPathFromState || returnPathFromParams;
        console.log("pathsssss", returnPathFromState, returnPathFromParams, finalReturnPath)

        if (finalReturnPath) {
            navigate(finalReturnPath, { replace: true });
        } else {
            navigate(`/SCHOOL/Teacher/EL_ViewWork?${searchParams.toString()}`);
        }
    };

    const styles = {
        container: {
            padding: '10px',
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#fff',
            fontSize: '12px',
            color: '#000',
            display: 'flex',
            flexDirection: 'column' as 'column',
            minHeight: '100vh',
            boxSizing: 'border-box' as 'border-box'
        },
        mainLayout: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '15px',
            flex: 1
        },
        imageContainer: {
            flexShrink: 0
        },
        formContainer: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column' as 'column',
            gap: '10px'
        },
        topRow: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '40px'
        },
        titleGroup: {
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
        },
        dateGroup: {
            display: 'flex',
            flexDirection: 'column' as 'column',
            gap: '5px',
            alignItems: 'flex-start'
        },
        dateRow: {
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
        },
        radioLabel: {
            marginLeft: '15px',
            fontWeight: 'normal',
            cursor: 'pointer'
        },
        label: {
            fontWeight: 'bold',
            color: '#000080'
        },
        input: {
            border: '1px solid #7F9DB9',
            padding: '2px',
            fontFamily: 'Arial',
            fontSize: '12px',
            width: '200px'
        },
        inputDate: {
            border: '1px solid #7F9DB9',
            padding: '2px',
            fontFamily: 'Arial',
            fontSize: '12px',
            width: '120px'
        },
        infoText: {
            marginTop: '5px',
            fontSize: '12px',
            color: '#000',
            fontWeight: "bold"
        },
        continueBtn: {
            cursor: 'pointer',
            backgroundColor: '#E0E0E0',
            border: '1px solid #000',
            padding: '2px 10px',
            fontWeight: 'bold',
            marginLeft: '5px',
            fontSize: '11px'
        }
    };

    return (
        <div style={styles.container}>
            {isLoading && <Loading />}
            <table id='tblHeader1' style={{ width: '100%', border: '0' }} cellPadding={0} cellSpacing={0}>
                <tbody>
                    <tr style={{ backgroundColor: '#E4E4E4' }}>
                        <td className='lableStyle' style={{ height: '26px', paddingLeft: '5px', verticalAlign: 'middle', fontFamily: 'Arial', fontSize: '13px', color: '#548BED', alignItems: 'left' }}>
                            eDealer: {familyCode} | Tutor: {studentName}
                        </td>
                        <td className='lableStyle' style={{ height: '26px', paddingRight: '15px', verticalAlign: 'middle', fontFamily: 'Arial', fontSize: '13px', color: '#548BED', textAlign: 'right' }}>
                            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                            <a
                                href="#"
                                id="lnkLogout"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleCancel();
                                }}
                            >
                                Cancel
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table id='tblHeader2' style={{ width: '100%', border: '0', borderCollapse: 'collapse', marginTop: '3px', marginBottom: '15px' }}>
                <tbody>
                    <tr style={{ backgroundColor: '#E4E4E4', fontFamily: 'Arial', fontSize: '16px' }}>
                        <td className='PageHeader' style={{ height: '26px', verticalAlign: 'middle', paddingLeft: '5px', fontWeight: 'bold' }}>Set Work</td>
                        <td style={{ height: '26px', verticalAlign: 'middle', textAlign: 'right', paddingRight: '15px' }}></td>
                    </tr>
                </tbody>
            </table>
            <div style={styles.mainLayout}>
                <div style={styles.imageContainer}>
                    <img src={sideImage1} alt="Side Decoration" />
                </div>

                <div style={styles.formContainer}>

                    <div style={styles.topRow}>
                        <div style={styles.titleGroup}>
                            <span style={styles.label}>Set Work Title:</span>
                            <input
                                type="text"
                                style={styles.input}
                                value={workTitle}
                                onChange={(e) => setWorkTitle(e.target.value)}
                            />
                        </div>

                        <div style={styles.dateGroup}>
                            <div style={styles.dateRow}>
                                <span style={styles.label}>Start Date:</span>&nbsp;
                                <input
                                    type="date"
                                    style={styles.inputDate}
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                                <input
                                    type="text"
                                    style={{ ...styles.input, width: '40px' }}
                                    value={startTime}
                                    onChange={(e) => setStartTime(e.target.value)}
                                />
                            </div>
                            <div style={styles.dateRow}>
                                <span style={styles.label}>Finish Date:</span>
                                <input
                                    type="date"
                                    style={styles.inputDate}
                                    value={finishDate}
                                    onChange={(e) => setFinishDate(e.target.value)}
                                />
                                <input
                                    type="text"
                                    style={{ ...styles.input, width: '40px' }}
                                    value={endTime}
                                    onChange={(e) => setEndTime(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        <div style={styles.infoText}>
                            <span style={{ fontWeight: 'bold' }}>Set Work For: </span>
                            <span style={{ fontWeight: 'bold' }}>{studentName}</span>
                            <span>({sessionStorage.getItem('surname')} family) </span>
                        </div>
                        <div style={styles.infoText}>
                            This option allows you to set work to specific student
                        </div>
                    </div>

                    <div style={styles.infoText}>
                        Click the Continue button to proceed.
                    </div>
                </div>
            </div>
            <table id='tblHeader1' style={{ width: '100%', border: '0', margin: 'auto' }} cellPadding={0} cellSpacing={0}>
                <tbody>
                    <tr>
                        <td style={{ height: '15px' }}></td>
                    </tr>
                    <tr id='trFooter'>
                        <td id='tdFooter' colSpan={5} style={{ backgroundColor: '#548BED' }}>
                            <table style={{ width: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td style={{ textAlign: 'left', verticalAlign: 'middle', paddingTop: '5px', paddingLeft: '20px', width: '50%', height: '36px' }}></td>
                                        <td style={{ textAlign: 'right', verticalAlign: 'middle', paddingRight: '20px' }}>
                                            <img
                                                src={isContinueHovered ? continue_o : continue_n}
                                                alt="Continue"
                                                style={{ cursor: 'pointer', border: '0' }}
                                                onMouseEnter={() => setIsContinueHovered(true)}
                                                onMouseLeave={() => setIsContinueHovered(false)}
                                                onClick={handleContinue}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    onClose={() => setAlertInfo({ ...alertInfo, show: false })}
                />
            )}
        </div>
    );
};

export default EL_SetWork;